import localeEs from '@angular/common/locales/es';
import localeEn from '@angular/common/locales/en';
import localePt from '@angular/common/locales/pt';
import { LocationStrategy, PathLocationStrategy, registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { metaReducers } from './app.metareducer';
import { ROOT_REDUCERS } from './app.reducer';
import { AuthInterceptor } from './auth/auth.interceptor';
import { SignInModule } from './auth/components/sign-in/sign-in.module';
import { ModalModule } from './components';
import { SpinnerModule } from './components/spinner/spinner.module';
import { CoreModule } from './core/core.module';
import { LayoutModule } from './layout/layout.module';
import { SharedModule } from './shared/shared.module';
import { WaitTimeBannerModule } from './components/wait-time-banner/wait-time-banner.module';
import { TransactionIdInterceptor } from './Interceptors/transactionId.interceptor';
import { AuthModule as OIDCAuthModule, StsConfigLoader } from 'angular-auth-oidc-client';
import { AuthModule as Auth0AuthModule } from '@auth0/auth0-angular';
import { OIDCAuthFactory, ConfigService, Auth0AuthFactory } from './auth/settings/auth.settings';
import { UnauthorizedContainerComponent } from './auth/components/unauthorized/containers/unauthorized-container/unauthorized-container.component';
import { SettingsModule } from './settings/settings.module';
import { LocaleService } from './shared/services/Locale.Service';
import { InactivityModule } from './counters/inactivity.module';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [AppComponent, UnauthorizedContainerComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    SpinnerModule,
    ModalModule,
    LayoutModule,
    SignInModule,
    InactivityModule,
    StoreModule.forRoot(ROOT_REDUCERS, {
      metaReducers,
      runtimeChecks: {
        strictStateImmutability: false,
        strictActionImmutability: false,
        strictStateSerializability: false
      }
    }),
    EffectsModule.forRoot([]),
    StoreDevtoolsModule.instrument(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      },
      isolate: false
    }),
    CoreModule,
    SharedModule.forRoot(),
    WaitTimeBannerModule,
    OIDCAuthModule.forRoot({
      loader: {
        provide: StsConfigLoader,
        useFactory: OIDCAuthFactory,
        deps: [ConfigService]
      }
    }),
    Auth0AuthModule.forRoot({
      skipRedirectCallback: !window.location.pathname.includes(
        Auth0AuthFactory().skipRedirectCallbackURL
      ),
      domain: Auth0AuthFactory().domain,
      clientId: Auth0AuthFactory().clientId,
      authorizationParams: {
        audience: Auth0AuthFactory().audience,
        scope: Auth0AuthFactory().scope,
        redirect_uri: Auth0AuthFactory().urlRedirect
      }
    }),
    SettingsModule
  ],
  providers: [
    LocaleService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TransactionIdInterceptor,
      multi: true
    },
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    {
      provide: LOCALE_ID,
      deps: [LocaleService],
      useFactory: (localizationService) => localizationService.getLocale()
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
registerLocaleData(localeEs);
registerLocaleData(localeEn);
registerLocaleData(localePt);
